import React, { useEffect } from 'react';
import './App.css';
import { ConfigProvider } from 'antd';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Home from './screens/Home/Home';
import Location from './screens/Location/Location';
import Inventory from './screens/Inventory/Inventory';

/**
 * AXIOS API CONFIGURATION
 */
import { configure } from 'axios-hooks'
import { LRUCache } from 'lru-cache';
import axios from 'axios'
import { CONFIG } from './utils/Common';
import Find from './screens/Find/Find';
import StockIn from './screens/StockIn/StockIn';

// var getConfig = {
//   "api-key": process.env.REACT_APP_API_KEY,
//   "Content-Type": "application/json",
//   "latitude": "1",
//   "longitude": "1",
// };

// request interceptor to add token to request headers
// axios.interceptors.request.use(
//   async (config) => {
//     config.headers = CONFIG
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

const axiosCfg = axios.create({
  baseURL: process.env.REACT_APP_API_LINK,
});
const cache = new LRUCache({ max: 10 })
configure({ axiosCfg, cache })


function App() {

  var theme = {
    token: {
      colorPrimary: "#00b96b",

      fontFamily: "Inter"
    }
  }

  return (
    <ConfigProvider theme={theme}>
      <Router>
        <Routes>
          <Route
            path="/"
            element={<Find/>}
          />
          <Route
            path="/find"
            element={<Find/>}
          />
          <Route
            path="/stockin"
            element={<StockIn/>}
          />
          <Route
            path="/location"
            element={<Location/>}
          />
          <Route
            path="/inventory"
            element={<Inventory/>}
          />
        </Routes>
      </Router>
    </ConfigProvider>
  );
}

export default App;
